export default "__VITE_ASSET__DawfItFa__"